import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QRService {
  trigger$: Subject<any> = new Subject();
}
